import { all } from 'redux-saga/effects'

import getTable from './getTable'
import getFile from './getFile'
import getSelectedElement from './getSelectedElement'
import getWidgetInformation from './getWidgetInformation'

export default function* root() {
  yield all([
    getTable(),
    getFile(),
    getSelectedElement(),
    getWidgetInformation(),
  ])
}
